import React, { Component } from "react";
import {Chart, registerables} from "chart.js";
import 'chartjs-adapter-luxon'
import SecondServer from "../../database/SecondServer";
import { siteAccessCode } from "../../database/apiv2SiteAccessor";
import { urlAlarmHistory } from "../../database/apiUrls";
import { timeLineObj } from "./TimelineChart";
import { chunkyHistory } from '../HistoricalData';
import { renderLoader } from "../../Loading/loading";
import { sanitizeDateTime, between, mediumFormat} from "../../timeFunctions/timeFns";
import {lastDay, lastWeek, lastMonth} from '../Controls/PeriodDropDown'
import FilterPanel from '../Controls/FilterPanel'
import "../report.css";
import { fetchNetworkStatus } from "../DataHelpers";
import EZNotify from "../../Alert/SimplerNotify";
import {dateObjSort} from '../../Report/helperfunctions'

export default class AlarmHistory extends Component {
  constructor(props) {
    super(props);

    this.state = {
      alarms: undefined,
      filterReport: null,
      errorMsg: "",
      endrange: new Date(),
      startrange: new Date(Date.now() - 168 * 3600 * 1000),
      intervalDropDown: this.props.intervalDropDown ?? 1,
      chart: undefined,
      isLoading: true,
      clickedIndex: undefined,
      clickedDevice: undefined,
    };
    this.alarmChart = undefined;
    this.chartRef = React.createRef();
    this.deviceChart = undefined
    this.deviceRef = React.createRef()
    this.ss = new SecondServer(props)
    this.loader = renderLoader()
    this.devices = undefined

    this.startRange = this.startRange.bind(this);
    this.setFilters = this.setFilters.bind(this);
  }

  async componentDidMount() {
    const site = this.props.getActiveSite()
    if (site?.site_details?.devices) {
      this.devices = site?.site_details?.devices
    }
    this.props.breadCrumb([{ display: "Alert History", click: undefined }]);
    Chart.register(...registerables);
    this.fetchData()
    // this.alarmChart = this.createChart(this.chartRef, this.alarmChart, this.state.chart)    
  }

  async componentDidUpdate(prevProps, prevState) {
    if (this.props?.update && prevProps.update < this.props.update) {   // refresh button
      if (this.state.intervalDropDown < 3) { 
        const intervals = [lastDay, lastWeek, lastMonth]
        const range = intervals[this.state.intervalDropDown]()
        this.setState ({startrange:range[0], endrange: range[1]})
      }
      this.fetchData();
    }
    if (prevState.startrange.getTime() !== this.state.startrange.getTime() ||
      prevState.endrange.getTime() !== this.state.endrange.getTime()) {
        this.fetchData();
    }
  }
  componentWillUnmount () {
    if (this.alarmChart)
      this.alarmChart.destroy()
  }
  createChart(ref, chart, data, title=undefined) {
    const ctx = ref.current?.getContext("2d");
    if (!ctx) return
    const config = timeLineObj ({...this, dataProp: data, title:title})
    if (typeof chart !== "undefined")
      chart.destroy();
    return new Chart(ctx, config);
  }
  async fetchData() {
    if (!this.state.isLoading) 
      this.setState({ isLoading: true });
    const ac = siteAccessCode(this.props.getActiveSite())
    const prom = this.ss.apiData(urlAlarmHistory(ac))
    //const prom = this.ss.mockProm ("test error msg")
    prom.then((apiResp) => {
      const alerts = apiResp?.data?.data?.alerts_status
      //console.log (alerts)
      const chartFmt = this.toChart(alerts)
      this.setState({alarms: alerts, chart: chartFmt, isLoading: false})
    })
    .catch(err => {
      console.log (err)
      this.setErrorMessage(err.toString());
    })

  }
  toChart (apiData) {
    if (Array.isArray(apiData)) {
      const apiMod = apiData.map ((a, index)=> ({...a, srcIndex:index}))
      const rangeData = apiMod.filter(a=>between(a.ViolationTime, this.state.startrange, this.state.endrange))
      return rangeData.map (a => ({
        x: sanitizeDateTime(a.ViolationTime),
        y:(a.state==='Alarmed'?2:1),
        monitor_point: a.monitor_point,
        tipTitle: a.DeviceId,
        tipBody: a.description,
        tipFooter: a.state +' at ' +
          mediumFormat(sanitizeDateTime(a.ViolationTime)),
        srcIndex: a.srcIndex,
          /*(a.alert_type === 'Change_Alert'? a.alm_description :
           (a.value==='4294967295'?"Disconnect": a.value)), */
      }))}
    else return undefined
  }
  setErrorMessage(msg) {
    if (msg.localeCompare(this.state.errorMsg))
      this.setState({ errorMsg: msg, isLoading:false });
  }
  clickedIndex = (index) => {
    const clicked = this.state.chart[index]?.tipTitle
    const chart2 = this.state.chart.filter(item => item.tipTitle === clicked)
    console.log (clicked, chart2)
    this.deviceChart = this.createChart(this.deviceRef, this.deviceChart, chart2, "Alarms for "+clicked)    
    this.setState({clickedIndex: index, clickedDevice: clicked})
    setTimeout(()=>this.loadReadings(clicked.toUpperCase()), 10)   //decouple load from click handler
  }
  needsNetworkData(alert_type) {
    //console.log (alert_type)
    return alert_type === 'Low Voltage Alert' || alert_type === 'Lost Power'
  }
  async loadReadings(deviceId) {
    const sd = this.state.startrange
    const ed = this.state.endrange
    const siteId = siteAccessCode(this.props.getActiveSite())
    const clicked = this.state.chart[this.state.clickedIndex]
    console.log (clicked)
    if (this.needsNetworkData(this.state.alarms[clicked.srcIndex].alm_description)) {
      const prom = fetchNetworkStatus(siteId, sd, ed, this.ss)
      prom.then(resp => {
        console.log (resp?.jsonResponse?.data?.data?.raw_data)
        const clickedDev = resp?.jsonResponse?.data?.data?.raw_data.filter(
          s=>s?.DeviceId?.toUpperCase() === deviceId)
        console.log (clickedDev)
        // format networkdata like readings: 
        // {rx_time: "8/7/2025 6:33:17 AM",
        //  values: [{53: 450614}, {5d: -1}, {FF: 0}]
        const deets = clickedDev.map(c =>
          ({values: {12: c.BattVolt/1000},
            rx_time: c.RXTime,})
        )
        console.log (deets)
        if (deets.length)
          this.updateChart(this.deviceChart, deets)
      })
      return
    }
    const resp = await chunkyHistory(this.ss, siteId, deviceId, sd, ed)
    console.log (resp)
    const chart2 = this.toDetail (resp, deviceId)
    this.updateChart(this.deviceChart, chart2)
    //this.setState({chart2: chart2})
  }
  toDetail (resp, deviceId) {
    const cse = parseInt(this.state.chart[this.state.clickedIndex].monitor_point ?? '0', 10)
    let units = ''
    if (this.devices) {
      const dev = this.devices.find(d => d.device_id.toUpperCase() === deviceId)
      units = dev?.sensors[cse]?.units ?? ''
    }
    //console.log (resp)
    const deets = resp.map (r=> 
      ({values: r.values[cse],
      rx_time: r.rx_time, 
      units: units}))
    return deets
  }
  updateChart (chart, data) {
    const dtFmt = { year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute:'numeric' };
    //console.log(data)
    const chartable = data.map (a => ({
      x: sanitizeDateTime(a.rx_time, {zone: 'UTC'}),
      y: Object.values(a?.values)[0],
      tipBody: sanitizeDateTime(a.rx_time, {zone: 'UTC'}).toLocaleString('en-us', dtFmt),
      tipFooter: Object.values(a?.values)[0] === -1 ? 'Disconnected' : 
        Object.values(a?.values)[0]?.toString()+' '+(a?.units??'') ?? "",
    }))
    dateObjSort (chartable, 'x')
    if (chartable.some(c => c.y === -1)) {
      const plot1 = chartable.filter (c => c.y !== -1)
      const plot2 = chartable.filter (c => c.y === -1)
      chart.config._config.data.datasets[2].data = plot1
      chart.config._config.data.datasets[3].data = plot2
    } 
    else {
      //console.log ("push ", chartable, "into", chart)
      chart.config._config.data.datasets[2].data = chartable
    } 
    chart.update()
  }
  startRange(newStart) {
    if (newStart && typeof newStart.getMonth === "function") {
      this.setState({ startrange: newStart });
      return newStart;
    } else return this.state.startrange;
  }
  setFilters(which, panelState) {
    if (which === "filter") {
      const search = panelState ?? "";
      this.filter(search);
    }
    if (which === "date") {
      const sd = panelState?.startTime ?? this.state.startrange;
      const ed = panelState?.endTime ?? this.state.endrange;
      const dd = panelState?.dropDown ?? this.state.intervalDropDown;
      this.setState({ startrange: sd, endrange: ed, intervalDropDown: dd });
    }
  }

  filter = (search) => {
    let arrFilter = this.state.alarms.slice(0);
    if (search?.length > 0) {
      const lsearch = search.toLowerCase();
      arrFilter = arrFilter.filter((item) =>
        Object.values(item).join().toLowerCase().includes(lsearch)
      );
    }
    const chartFmt = this.toChart(arrFilter)
    this.setState({ chart: chartFmt, });
  };

  render() {
    if (this.alarmChart !== undefined)
      this.alarmChart.destroy()
    this.alarmChart = this.createChart(this.chartRef, this.alarmChart, this.state.chart)
    return(
      <div className="container-fluid">
        <FilterPanel {...this.props} dropDown={this.state.intervalDropDown}
          propagateState={this.setFilters} startTime={this.state.startrange}
          endTime={this.state.endrange} /> 
        {this.state.isLoading ? this.loader : null}
        <EZNotify message={this.state.errorMsg} styleName="danger" /> 
        <div className='graphContainer'>
          <canvas id="alarmHist" ref={this.chartRef} />
        </div>
        <div className='graphContainer' >
          <canvas id='deviceHist' ref={this.deviceRef} />
        </div>
      </div>
    )
  }
}
